import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 50,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",
    justifyContent: "center",
    width: "40%",
    margin: "auto",
  },
  topText: {
    color: "#525252",
    textAlign: "center",
  },
  formSection: {
    flex: "none",
    order: 0,
    flexGrow: 0,
    marginTop: "1rem",
  },
  enroleeIdText: {
    color: "#5A5454",
  },
  enroleeInputId: {
    outline: "none",
    backgroundColor: "transparent",
    color: "#5A5454",
    border: "1px solid #C4C4C4",
    borderRadius: "4px",
    padding: "0.5rem",
    marginTop: "0.2rem",
    width: "100%",
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    color: '#000',
  },
  actionButton: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "1rem",
  },
  proceedBtn: {
    color: "#FCFCFC",
    backgroundColor: "#E6072C",
    borderRadius: "5px",
    padding: "0.8rem 2rem",
    marginRight: 10,
  },
  cancelBtn: {
    color: "#E6072C",
    backgroundColor: "#F5E9EB",
    borderRadius: "5px",
    padding: "0.8rem 2rem",
  },
}));

const NonEnrolleesModal = ({ isOpen, onClose, onSubmit, enrolleeData, selecteId }) => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    transaction_id:'',
    price:'',
    sex: 'male'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      user_id: selecteId,
      benefits: enrolleeData.benefits,
      basic_plan_demographics: enrolleeData.basic_plan_demographics,
      status:'pending',
      price: formData?.price,
      transaction_id: formData?.transaction_id,
      sex: formData.sex
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.paper}>
        <h2 className={classes.title}>Activate Enrollee</h2>
        <form onSubmit={handleSubmit} className={classes.formSection}>
          <div>
            <label className={classes.enroleeIdText}>Full Name</label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className={classes.enroleeInputId}
            />
          </div>
         
          
          <div>
            <label className={classes.enroleeIdText}>Price</label>
            <input
              type="price"
              name="price"
              value={formData.price}
              onChange={handleChange}
              className={classes.enroleeInputId}
            />
          </div>
          <div>
            <label className={classes.enroleeIdText}>Transaction ID</label>
            <input
              type="transaction_id"
              name="transaction_id"
              value={formData.transaction_id}
              onChange={handleChange}
              className={classes.enroleeInputId}
            />
          </div>
          <div>
            <label className={classes.enroleeIdText}>Sex</label>
            <select  name="sex"
              value={formData.sex}
              onChange={handleChange}
               className={classes.enroleeInputId}>
              <option value='male' >Male</option>
              <option value='female' >Female</option>
              </select>
           
          </div>
        
          <div className={classes.actionButton}>
            <button
              type="button"
              onClick={onClose}
              className={classes.cancelBtn}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={classes.proceedBtn}
            >
              Activate
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NonEnrolleesModal;